import { Trash2 } from "lucide-react";
import { AuthImg, card, outcomeOf } from "@/components/laser/LaserParts";

const SETS = [["power_percent", "Power", "%"], ["frequency_khz", "Freq", " kHz"], ["pulse_width_ns", "Pulse", " ns"], ["speed_mm_s", "Speed", " mm/s"], ["pattern", "Pattern", ""], ["pattern_size_mm", "Size", " mm"], ["hatch_1_mm", "Hatch", " mm"], ["hatch_2_mm", "Hatch 2", " mm"], ["focal_distance_mm", "Focal", " mm"], ["passes", "Passes", ""]];

export const SettingTiles = ({ s }) => (
  <div className="flex flex-wrap gap-2">
    {SETS.filter(([k]) => s[k] != null).map(([k, l, u]) => (
      <div key={k} style={{ flex: "1 1 0", minWidth: 84, padding: "6px 9px", borderRadius: 8, background: "#0A0A0A", border: "1px solid #333" }}>
        <p style={{ color: "#A0A0A0", fontSize: 9, fontWeight: 800, letterSpacing: 0.8 }}>{l.toUpperCase()}</p>
        <p style={{ color: "#fff", fontSize: 14, fontWeight: 700 }}>{typeof s[k] === "number" ? s[k].toLocaleString() : s[k]}{u}</p>
      </div>
    ))}
  </div>
);

export default function CalibrationCard({ c, onDelete }) {
  const [, label, color] = outcomeOf(c.outcome);
  return (
    <div data-testid={`calibration-${c.id}`} style={{ ...card, padding: 16 }}>
      <div className="mb-2 flex items-start gap-3">
        <span style={{ padding: "3px 8px", borderRadius: 6, border: "1px solid #4CCC06", color: "#4CCC06", fontSize: 12, fontWeight: 800 }}>{c.machine_name}</span>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-bold">{c.substrate_detail} · {c.contaminant}</p>
          <p className="text-xs text-neutral-400">{[c.layers && `${c.layers} layer(s)`, c.metal_thickness_mm && `${c.metal_thickness_mm} mm thick`, new Date(c.created_at).toLocaleDateString()].filter(Boolean).join(" • ")}{c.mine ? " • your test" : ""}</p>
        </div>
        <span data-testid={`calibration-outcome-${c.id}`} style={{ padding: "3px 9px", borderRadius: 999, fontSize: 11, fontWeight: 800, color, border: `1px solid ${color}` }}>{label}</span>
        {c.mine && onDelete && <button data-testid={`calibration-delete-${c.id}`} aria-label="Delete test" onClick={() => onDelete(c)} style={{ padding: 6, borderRadius: 8, border: "1px solid #333", color: "#A0A0A0" }}><Trash2 size={15} /></button>}
      </div>
      <SettingTiles s={c} />
      {(c.before_photo_id || c.after_photo_id) && (
        <div className="mt-3 grid grid-cols-2 gap-2">
          {c.before_photo_id ? <AuthImg id={c.before_photo_id} alt="Before" lazyVideo={(c.before_media_type || "").startsWith("video/")} testId={`calibration-before-${c.id}`} /> : <span />}
          {c.after_photo_id ? <AuthImg id={c.after_photo_id} alt="After" lazyVideo={(c.after_media_type || "").startsWith("video/")} testId={`calibration-after-${c.id}`} /> : <span />}
        </div>
      )}
      {c.notes && <p className="mt-3 text-[13px] text-neutral-300">{c.notes}</p>}
    </div>
  );
}
